(function () {
  'use strict';

  var API_URL = 'https://api.judge.me/api/v1/widgets/all_reviews_page.json';
  var REVIEW_API_URL = 'https://judge.me/api/v1/reviews';
  var STORE_VERIFIED_REVIEW_IDS = new Set([
    '028f0549-8b10-4a3c-a1d3-9826c61aa835',
    '0a448746-609a-4219-91c6-eae613d413d5',
    '131a8da3-40f9-4291-b4ab-d1143b7a166f',
    '17f81bba-02b4-4d6b-bbe4-42390e4bd06c',
    '1b4b1a1b-1fc0-40c8-a6ca-f73134bb710b',
    '1bb289bf-60bd-4caa-9f1c-da2b8e9284a3',
    '1e3fe225-fb21-47d2-adae-c71000a035cd',
    '217c2c4e-4cd1-49ce-84ed-7314357ae5ef',
    '27de8149-29ea-43e4-b129-036bcd2ab82e',
    '2fd947a5-b6ae-4159-ad66-94a77b4594a5',
    '3545fc4b-0ca0-49b1-9138-112d561c27f0',
    '3ee21f30-76d0-4660-ab69-cd5a8a0df045',
    '41191277-6479-40bf-a183-3878a3c0e55b',
    '4218cfd3-869d-4ff0-a8b3-160b2ba16842',
    '43fe3a31-cd71-4c07-b1f6-7934d329f084',
    '47b12a10-3fcd-49ee-8e96-015b540fed26',
    '48645b8f-c948-4bca-bd99-7e458cfb97dc',
    '5b70c814-7059-4eb5-b4cc-6a14928c1c81',
    '610ad25b-0b72-4f83-9a71-fd1a15264135',
    '61f2c831-a0c0-4517-9459-f299fa139df7',
    '68f9a841-2847-4c4f-943e-236326c05a88',
    '69b34377-dc2b-485d-a22f-5ef728d6dafd',
    '6fa54d1b-b70d-4ec9-a8b7-f578697e29ba',
    '704a5bb4-9d82-4191-bdf3-8396455f6a33',
    '7845c564-a81a-4fee-907b-f0ebf893d73d',
    '7c0e70c2-026d-4a04-8e6f-7f13d683621b',
    '7eadca4c-b9aa-430e-a71e-8c79a58b855d',
    '888fdaaf-568a-4cba-8b17-a90edad5bdd0',
    '9566e0ad-d078-4ed0-9e28-a2f34e51ca65',
    '9988ebcb-4eb5-4c56-aed8-d5b8e58f9f31',
    '9e3d0f39-ba76-4c4e-b330-b92cbea28643',
    'a90dcda0-83de-4261-8069-0c2d16c93722',
    'ae56ebcf-6c0e-4eed-bd32-b18478fe2fe9',
    'b6ea6a43-e73f-404f-adb1-9d910b496eba',
    'bdca1040-ba2d-44c6-88f6-e705ececb801',
    'bf9d8430-2f93-473d-ac85-572540676b60',
    'daf7cb69-a549-46e7-9997-9cfda56ca12d',
    'dc83b0d9-1782-4491-adbf-d25ec5f8d448',
    'ddcf27fd-d265-4b99-8ebe-83bfdda2dd03',
    'e0ae299a-b7e1-46f2-9e9a-5eacd731c0da',
    'e38ed48b-3ef6-41c1-a489-8ea179aa57ab',
    'e4401e52-3b9c-4e4b-b23d-988f35fdd081',
    'e47a867f-87e1-48e8-ab31-20aca6f8b820',
    'e7edb086-83aa-4991-9f38-a67204b3a828',
    'ed56ee4d-acb2-4805-9bb0-3de6afe2e971',
    'f1f9ebb2-8164-409b-a7d4-455179f5a1f7',
    'f941cc18-38c2-4585-a6f4-893e486ecdcc',
    'fb2cbfd2-baec-4b9f-8d55-4ac76f4d9ef4',
    'fce8b585-bac7-4428-b4bb-55848376f04b',
    'fd82b050-41a6-4464-8ff6-e17bb20fab99',
    'feddacb9-5a86-46c5-8c90-80c823a1c8c6'
  ]);

  function safeUrl(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : '';
    } catch (error) {
      return '';
    }
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function formatDate(value) {
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    }).format(date);
  }

  function createStars(rating) {
    var stars = element('div', 'aceites-reviews__stars');
    stars.appendChild(element('span', 'aceites-reviews__stars-filled', '★'.repeat(rating)));
    stars.appendChild(element('span', 'aceites-reviews__stars-empty', '☆'.repeat(5 - rating)));
    stars.setAttribute('aria-label', rating + ' de 5 estrellas');
    return stars;
  }

  function createReview(review) {
    var card = element('article', 'aceites-reviews__card');
    var head = element('div', 'aceites-reviews__card-head');
    var rating = Math.max(3, Math.min(5, Number(review.rating) || 3));
    var date = element('time', 'aceites-reviews__date', formatDate(review.created_at));

    date.dateTime = review.created_at || '';
    head.appendChild(createStars(rating));
    head.appendChild(date);
    card.appendChild(head);

    if (review.title) {
      card.appendChild(element('h2', 'aceites-reviews__title', review.title));
    }
    if (review.body) {
      card.appendChild(element('p', 'aceites-reviews__body', review.body));
    }

    if (Array.isArray(review.pictures_urls) && review.pictures_urls.length) {
      var photos = element('div', 'aceites-reviews__photos');
      review.pictures_urls.slice(0, 4).forEach(function (picture, index) {
        var src = safeUrl(
          typeof picture === 'string'
            ? picture
            : picture.compact || picture.small || picture.original || picture.huge
        );
        if (!src) return;
        var link = element('a', 'aceites-reviews__photo-link');
        var originalSrc = safeUrl(
          typeof picture === 'string'
            ? picture
            : picture.original || picture.huge || picture.compact || picture.small
        );
        var image = element('img', 'aceites-reviews__photo');
        image.src = src;
        image.alt = 'Foto de la opinión ' + (index + 1);
        image.loading = 'lazy';
        image.width = 78;
        image.height = 78;
        link.href = originalSrc || src;
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', 'Abrir foto de la opinión ' + (index + 1));
        link.appendChild(image);
        photos.appendChild(link);
      });
      if (photos.childElementCount) card.appendChild(photos);
    }

    if (review.reply_content) {
      var reply = element('div', 'aceites-reviews__reply');
      reply.appendChild(element('strong', '', 'Respuesta de Aceite Córdoba'));
      reply.appendChild(element('span', '', review.reply_content));
      card.appendChild(reply);
    }

    var footer = element('footer', 'aceites-reviews__footer');
    var author = element('div', 'aceites-reviews__author');
    author.appendChild(element('strong', '', review.reviewer_name || 'Cliente'));
    if (review.verified_buyer) {
      author.appendChild(element('span', 'aceites-reviews__verified', 'Compra verificada'));
    } else if (STORE_VERIFIED_REVIEW_IDS.has(review.uuid)) {
      author.appendChild(element(
        'span',
        'aceites-reviews__verified aceites-reviews__verified--store',
        'Compra verificada'
      ));
    }
    footer.appendChild(author);

    if (!review.is_shop_review && review.product_title && review.product_url) {
      var product = element('a', 'aceites-reviews__product');
      product.href = safeUrl(review.product_url) || review.product_url;
      product.setAttribute('aria-label', 'Ver ' + review.product_title);

      var imageUrl = safeUrl(review.product_variant_image_url || review.product_pictures_url);
      if (imageUrl) {
        var productImage = element('img');
        productImage.src = imageUrl;
        productImage.alt = '';
        productImage.loading = 'lazy';
        productImage.width = 48;
        productImage.height = 48;
        product.appendChild(productImage);
      }
      product.appendChild(element('span', '', review.product_title));
      footer.appendChild(product);
    }

    card.appendChild(footer);
    return card;
  }

  function initReviews(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var grid = root.querySelector('[data-reviews-grid]');
    var status = root.querySelector('[data-reviews-status]');
    var empty = root.querySelector('[data-reviews-empty]');
    var more = root.querySelector('[data-reviews-more]');
    var count = root.querySelector('[data-reviews-count]');
    var average = root.querySelector('[data-reviews-average]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-rating]'));
    var formToggle = root.querySelector('[data-review-form-toggle]');
    var formPanel = root.querySelector('[data-review-form-panel]');
    var reviewForm = root.querySelector('[data-review-form]');
    var formMessage = root.querySelector('[data-review-form-message]');
    var submitButton = root.querySelector('[data-review-submit]');
    var nativeReviewButton = root.querySelector('.jdgm-write-rev-link');
    var nativeReviewSource = root.querySelector('.aceites-reviews__native-source');
    var ratingLabels = Array.prototype.slice.call(root.querySelectorAll('[data-review-rating] label'));
    var state = { filter: 'all', page: 0, totalPages: 1, loading: false, pendingReview: null };
    var mobileReviewScrollY = 0;

    function syncNativeReviewForm() {
      var isOpen = nativeReviewButton && nativeReviewButton.classList.contains('close-form-btn');
      var hasNotification = nativeReviewSource && nativeReviewSource.querySelector('.jdgm-notification');
      var shouldShowSource = Boolean(isOpen || hasNotification);
      var isMobile = window.matchMedia('(max-width: 767px)').matches;

      formToggle.textContent = isOpen ? 'Cerrar formulario' : 'Deja tu opinión';
      formToggle.setAttribute('aria-expanded', String(Boolean(isOpen)));
      document.documentElement.classList.toggle(
        'aceites-reviews-mobile-form-open',
        Boolean(isMobile && isOpen)
      );
      if (nativeReviewSource) {
        nativeReviewSource.classList.toggle('is-form-open', shouldShowSource);
        nativeReviewSource.setAttribute('aria-hidden', String(!shouldShowSource));
      }
    }

    function localizeShopSignInModal() {
      document.querySelectorAll('[role="dialog"]').forEach(function (dialog) {
        var prompt = Array.prototype.find.call(dialog.querySelectorAll('p'), function (item) {
          return item.textContent.trim() === 'How would you like to continue?';
        });
        var guestButton = Array.prototype.find.call(dialog.querySelectorAll('button'), function (item) {
          var label = item.textContent.trim();
          return label === 'Continue without signing in' || label === 'Continuar sin iniciar sesión';
        });
        var closeButton = dialog.querySelector('.jdgm-modal-block__close-button');

        if (prompt && prompt.textContent.trim() !== '¿Cómo quieres continuar?') {
          prompt.textContent = '¿Cómo quieres continuar?';
        }
        if (guestButton && guestButton.textContent.trim() !== 'Continuar sin iniciar sesión') {
          guestButton.textContent = 'Continuar sin iniciar sesión';
        }
        if (closeButton && closeButton.getAttribute('aria-label') !== 'Cerrar ventana') {
          closeButton.setAttribute('aria-label', 'Cerrar ventana');
        }
      });
    }

    localizeShopSignInModal();
    new MutationObserver(localizeShopSignInModal).observe(document.body, {
      childList: true,
      subtree: true
    });

    function stabilizeMobileReviewForm() {
      if (!window.matchMedia('(max-width: 767px)').matches) return false;

      var activeElement = document.activeElement;
      if (
        activeElement &&
        nativeReviewSource &&
        nativeReviewSource.contains(activeElement) &&
        typeof activeElement.blur === 'function'
      ) {
        activeElement.blur();
      }
      window.scrollTo({ top: mobileReviewScrollY, left: 0, behavior: 'auto' });
      return true;
    }

    function scrollToNativeForm() {
      if (stabilizeMobileReviewForm()) return;
      var nativeFormWrapper = nativeReviewSource && nativeReviewSource.querySelector('.jdgm-form-wrapper');
      if (nativeFormWrapper) {
        nativeFormWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    function openNativeReviewForm(attempt) {
      if (!nativeReviewButton || nativeReviewButton.classList.contains('close-form-btn')) {
        syncNativeReviewForm();
        scrollToNativeForm();
        return;
      }

      nativeReviewButton.click();
      if (window.matchMedia('(max-width: 767px)').matches) {
        [0, 150, 450].forEach(function (delay) {
          window.setTimeout(stabilizeMobileReviewForm, delay);
        });
      }
      window.setTimeout(function () {
        if (nativeReviewButton.classList.contains('close-form-btn')) {
          syncNativeReviewForm();
          scrollToNativeForm();
        } else if (attempt < 5) {
          openNativeReviewForm(attempt + 1);
        }
      }, 250);
    }

    function updateSummary(data) {
      if (!Array.isArray(data.rating_histogram_data)) return;
      var allowed = data.rating_histogram_data.filter(function (item) {
        return Number(item.rating) >= 3;
      });
      var total = allowed.reduce(function (sum, item) {
        return sum + Number(item.frequency || 0);
      }, 0);
      var weighted = allowed.reduce(function (sum, item) {
        return sum + Number(item.rating) * Number(item.frequency || 0);
      }, 0);

      if (total) {
        count.textContent = new Intl.NumberFormat('es-ES').format(total);
        average.textContent = (weighted / total).toLocaleString('es-ES', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
    }

    function setLoading(isLoading) {
      state.loading = isLoading;
      grid.setAttribute('aria-busy', String(isLoading));
      more.disabled = isLoading;
      if (isLoading && state.page > 0) more.textContent = 'Cargando…';
      if (!isLoading) more.textContent = 'Ver más opiniones';
    }

    function buildUrl(page) {
      var params = new URLSearchParams({
        platform: 'shopify',
        shop_domain: root.dataset.shopDomain,
        api_token: root.dataset.apiToken,
        add_header_counts: 'true',
        page: String(page),
        per_page: root.dataset.perPage || '12',
        json_request: 'true',
        review_type: 'all-reviews',
        review_source: 'all_sources',
        verified_only: 'false'
      });
      if (state.filter !== 'all') params.set('filter_rating', state.filter);
      return API_URL + '?' + params.toString();
    }

    function loadReviews(reset) {
      if (state.loading) return;
      if (reset) {
        state.page = 0;
        state.totalPages = 1;
        state.pendingReview = null;
        grid.replaceChildren();
        empty.hidden = true;
      }

      var nextPage = state.page + 1;
      setLoading(true);
      status.textContent = 'Cargando opiniones';

      fetch(buildUrl(nextPage), { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('No se pudieron cargar las opiniones');
          return response.json();
        })
        .then(function (data) {
          updateSummary(data);
          state.page = Number(data.current_page) || nextPage;
          state.totalPages = Number(data.total_pages) || state.page;

          var reviews = Array.isArray(data.reviews) ? data.reviews : [];
          reviews = reviews.filter(function (review) {
            var rating = Number(review.rating);
            return rating >= 3 && rating <= 5;
          });

          if (state.pendingReview) {
            reviews.unshift(state.pendingReview);
            state.pendingReview = null;
          }

          if (reviews.length % 2 !== 0) {
            state.pendingReview = reviews.pop();
          }

          var fragment = document.createDocumentFragment();
          reviews.forEach(function (review) {
            fragment.appendChild(createReview(review));
          });
          grid.appendChild(fragment);

          empty.hidden = grid.childElementCount > 0;
          more.hidden = state.page >= state.totalPages;
          status.textContent = reviews.length + ' opiniones cargadas';
        })
        .catch(function () {
          empty.hidden = grid.childElementCount > 0;
          more.hidden = true;
          status.textContent = 'No se han podido cargar las opiniones. Actualiza la página para volver a intentarlo.';
        })
        .finally(function () {
          setLoading(false);
        });
    }

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        if (state.loading || state.filter === filter.dataset.rating) return;
        state.filter = filter.dataset.rating;
        filters.forEach(function (button) {
          var active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        loadReviews(true);
      });
    });

    more.addEventListener('click', function () { loadReviews(false); });

    formToggle.addEventListener('click', function () {
      nativeReviewButton = root.querySelector('.jdgm-write-rev-link');
      if (nativeReviewButton) {
        if (nativeReviewButton.classList.contains('close-form-btn')) {
          nativeReviewButton.click();
          window.setTimeout(syncNativeReviewForm, 100);
        } else {
          mobileReviewScrollY = window.scrollY;
          openNativeReviewForm(0);
        }
        return;
      }
      var willOpen = formPanel.hidden;
      formPanel.hidden = !willOpen;
      formToggle.setAttribute('aria-expanded', String(willOpen));
      formToggle.textContent = willOpen ? 'Cerrar formulario' : 'Deja tu opinión';
      if (willOpen) {
        var firstRating = reviewForm.querySelector('input[name="rating"]');
        if (firstRating) firstRating.focus();
      }
    });

    if (nativeReviewButton) {
      new MutationObserver(syncNativeReviewForm).observe(nativeReviewButton, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    if (nativeReviewSource) {
      new MutationObserver(syncNativeReviewForm).observe(nativeReviewSource, {
        childList: true,
        subtree: true
      });
    }

    ratingLabels.forEach(function (label) {
      var input = label.querySelector('input');
      input.addEventListener('change', function () {
        var selected = Number(input.value);
        ratingLabels.forEach(function (item) {
          item.classList.toggle('is-on', Number(item.dataset.value) <= selected);
        });
      });
    });

    reviewForm.addEventListener('submit', function (event) {
      event.preventDefault();
      formMessage.textContent = '';
      formMessage.classList.remove('is-error');
      submitButton.disabled = true;
      submitButton.textContent = 'Enviando…';

      var formData = new FormData(reviewForm);
      var payload = new URLSearchParams({
        shop_domain: root.dataset.shopDomain,
        platform: 'shopify',
        name: formData.get('name'),
        email: formData.get('email'),
        rating: formData.get('rating'),
        title: formData.get('title') || '',
        body: formData.get('body'),
        reviewer_name_format: 'last_initial'
      });

      fetch(REVIEW_API_URL, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) throw new Error(data.message || 'No se ha podido enviar la reseña.');
            return data;
          });
        })
        .then(function () {
          reviewForm.reset();
          ratingLabels.forEach(function (label) { label.classList.remove('is-on'); });
          formMessage.textContent = '¡Gracias por compartir tu experiencia! Revisa tu correo para confirmar la reseña.';
        })
        .catch(function (error) {
          formMessage.textContent = error.message || 'No se ha podido enviar la reseña. Inténtalo de nuevo.';
          formMessage.classList.add('is-error');
        })
        .finally(function () {
          submitButton.disabled = false;
          submitButton.textContent = 'Enviar reseña';
        });
    });

    loadReviews(true);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-aceites-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
